import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotRecommendations from './components/HotRecommendations';
import CategorySection from './components/CategorySection';
import LatestVideos from './components/LatestVideos';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import { faqs } from '@/mocks/faqs';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '福利视频在线',
      url: 'https://fulishipin.com',
      description: '福利视频在线是您发现海量精彩内容的最佳入口，汇聚热门影视、综艺、短视频资源，无需下载即可流畅播放。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-0000',
        contactType: 'customer service',
        email: 'contact@fulishipin.com',
      },
    },
    {
      '@type': 'WebSite',
      name: '福利视频在线',
      url: 'https://fulishipin.com',
      description: '海量高清影视综艺短视频资源免费在线播放平台',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      name: '福利视频在线 - 首页',
      description: '福利视频在线免费观看平台首页，提供热门影视、综艺、短视频免费在线播放。',
      url: 'https://fulishipin.com',
      isPartOf: { '@id': 'https://fulishipin.com/#website' },
      about: { '@id': 'https://fulishipin.com/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20and%20amber%20flowing%20light%20streaks%20on%20dark%20background%2C%20cinematic%20atmosphere%2C%20elegant%20geometric%20patterns&width=1920&height=1080&seq=hero-bg-main&orientation=landscape',
      },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://fulishipin.com',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommendations />
          <CategorySection />
          <LatestVideos />
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
      </div>
    </>
  );
}